module.exports = __webpack_public_path__ + "static/media/harp.72ef09ce.svg";